import { Card, Typography } from '@mui/material';

export default function Vision() {
    return (
        <Card className="card">
            <Typography variant="h5" gutterBottom>未来展望</Typography>
            <Typography>
                我们将继续深耕人工智能领域，推动技术商业化应用...
            </Typography>
        </Card>
    );
}
